export const styles = {
    container: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
    },
    tagImage: {
        height: 25,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        background: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderRadius: '4px',
    },
    tagTripAdvisor: {
        width: 81,
    },
    tagTripAdvisorLogo: {
        height: 17,
        width: 63,
    },
    tagBooking: {
        width: 84,
    },
    tagBookingLogo: {
        height: 12,
        width: 66,
    },
    tagSletat: {
        width: 77,
    },
    tagSletatLogo: {
        width: 59,
        height: 16,
    },
    tagTopHotels: {
        width: 62,
    },
    tagTopHotelsLogo: {
        height: 16,
        width: 44,
    },
    tagTourPravdaLogo: {
        height: 10,
        paddingTop: 2,
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
